module.exports = __webpack_public_path__ + "static/media/washington-dc-23.256647ae.jpg";